import React, { createContext, useState, useEffect } from "react";
import { getUserByToken } from "../services/user/user";
import { getCookie } from "../helper/cookie";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const token = getCookie("token");

  useEffect(() => {
    const fetchUser = async () => {
      if (!token) return;
      const [userData] = await getUserByToken(token);
      setCurrentUser(userData || null);
    };
    fetchUser();
  }, [token]);

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser }}>
      {children}
    </UserContext.Provider>
  );
};
